import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutocompleteOptions, DropdownOptions, FileUploadOptions, FileType, FilterItem, FilterType, InputType, PagingOptions, TextAreaOptions, TextBoxOptions, MultiLingualTextAreaOptions, EnglishArabicDTO } from 'bbsf-controls';
import { EditResourceModel } from '../shared/models/LocalizationModels/EditResourceModel';
import { localizationsService } from '../shared/Services/localizationsService.service ';
import { UploadJsonVM } from '../shared/models/LocalizationModels/UploadJsonVM';
import { ClipboardService } from 'ngx-clipboard';
import { DatePipe } from '@angular/common';
import { PageInfoService } from '../../_metronic/core/services/page-info.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bbsf-utilities';

@Component({
  selector: 'lib-localizations',
  templateUrl: './localizations.component.html',
  styleUrls: ['./localizations.component.css']
})
export class LocalizationsComponent implements OnInit {

  ApiUrl = "/api/admin/Localizations/"
  ResourceSetOptions: DropdownOptions;
  searchTextBox: TextBoxOptions;
  SelectedLocalizationList = [];
  ResourceSetList = [];
  filterForm = new FormGroup({});
  LocalizationForm = new FormGroup({});
  showFilter: boolean = false;
  LocalizationPagingResult: any[] = [];
  LocalizationPaging: PagingOptions;
  ResourceSetFilter: FilterItem;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;

  //Add Model Controls
  AddResourceForm = new FormGroup({});
  ResourceSet: AutocompleteOptions;
  ResourceId: TextBoxOptions;
  MultiLingualValue:MultiLingualTextAreaOptions
  MultiLingualComment:MultiLingualTextAreaOptions
  @ViewChild('CloseResourceModal', { static: false }) CloseResourceModal: ElementRef;


  //Edit Model Controls
  EditResourceForm = new FormGroup({});
  EditMultiLingualValue:MultiLingualTextAreaOptions
  EditMultiLingualComment:MultiLingualTextAreaOptions
  resourceId: string;
  resourceSet: string;
  @ViewChild('CloseEditResourceModal', { static: false }) CloseEditResourceModal: ElementRef;
  @ViewChild('EditResourceModal', { static: false }) EditResourceModal: ElementRef;
  @ViewChild('LocalizationPagingViewElement', { static: false }) input: ElementRef;
  //GenerateStronglyTypedClass
  StronglyTypedClass: TextAreaOptions;
  ValueToCopy: string = "";
  GenerateCodeForm = new FormGroup({});

  //Upload Model Controls
  UploadJsonFileForm = new FormGroup({});
  UploadResourceSetOptions: DropdownOptions;
  ResourcesFileInput: FileUploadOptions;

  @ViewChild('CloseUploadJsonFileModal', { static: false }) CloseUploadJsonFileModal: ElementRef;

  //delete  Model Controls
  deleteResourceList: any[] = []
  @ViewChild('CloseDeleteResourceModal', { static: false }) CloseDeleteResourceModal: ElementRef;


  //Confirmation  Model Controls
  ConfirmationModalType: number = 0;
  ConfirmationMessage: string = "";
  HeaderMessage: string = "";
  @ViewChild('CloseConfirmationModal', { static: false }) CloseConfirmationModal: ElementRef;


  
  //ResourceValidationModalControls
  ExcelValidation:any;
  @ViewChild('ShowResourceValidationModal', { static: false }) ShowResourceValidationModal: ElementRef;
  @ViewChild('CloseResourceValidationModal', { static: false }) CloseResourceValidationModal: ElementRef;
  language:string="";

 
  ShowPageContent:boolean=false;
  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private datePipe: DatePipe, private _clipboardService: ClipboardService,private localizationsService: localizationsService, private modalService: NgbModal) {
  }
  async ngOnInit() {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Localization")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

 

  ReinitializeLocalizationPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateLocalizationPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setLocalizationListResult(result) {
    this.LocalizationPagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI();
  }


  selectAllLocalizationList(event, Localizations) {
    if (event.target.checked) {
      for (let index = 0; index < Localizations.length; index++) {
        const Localization = Localizations[index];
        const element = document.getElementById("Localization-" + Localization.ResourceId);
        element.setAttribute("checked", "checked");
        this.SelectedLocalizationList.push(Localization);
      }
    }
    if (!event.target.checked) {
      for (let index = 0; index < Localizations.length; index++) {
        const Localization = Localizations[index];
        const element = document.getElementById("Localization-" + Localization.ResourceId);
        element.removeAttribute("checked");
      }
      this.SelectedLocalizationList = [];
    }
  }

  loadFilters() {
    if (this.showFilter === false) {
      this.showFilter = true;
    } else {
      this.showFilter = false;
    }
  }


  LoadDropdownLists() {

    this.localizationsService.Loaddropdowns().subscribe((result) => {
      this.ResourceSetList = result as any
      // Resource Set Init   
      this.ResourceSetOptions = new DropdownOptions();
      this.ResourceSetOptions.Name = "ResourceSet"
      this.ResourceSetOptions.LabelKey = "ResourceSet"
      this.ResourceSetOptions.DataSource = this.ResourceSetList
      this.ResourceSetOptions.SingleSelection = true;
      this.ResourceSetOptions.AllowSearchFilter = true;
      this.ResourceSetOptions.Placeholder = "";

      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true;
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByNameOrResourceID")
      


      this.ResourceSetFilter = new FilterItem();
      this.ResourceSetFilter.FormControlName = "ResourceSet"
      this.ResourceSetFilter.ActionParameterName = "resourceSet"
      this.ResourceSetFilter.IsFormControl = true
      this.ResourceSetFilter.FilterType = FilterType.DropdownList


      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "resourceName"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox


      this.LocalizationPaging = new PagingOptions();
      this.LocalizationPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetLocalizationsByFilter';
      this.LocalizationPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.LocalizationPaging.DropdownFiltersControlNames = ["ResourceSet"];
      this.LocalizationPaging.Filters = [this.ResourceSetFilter, this.TextInputFilter]
      this.LocalizationPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
       
    })
  }


  resetFilters() {
    this.LocalizationForm.controls["ResourceSet"].setValue([]);
    this.LocalizationForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();

  }

  exportExcel(ExportAsTemplate:boolean=false) {
    let UsersFormFilters = this.LocalizationForm.value
    let params = new HttpParams();
    params = params.append("resourceSet", this.LocalizationForm.controls["ResourceSet"].value == undefined ? "" : this.LocalizationForm.controls["ResourceSet"].value);
    params = params.append("resourceName", this.LocalizationForm.controls["searchTextBox"].value == undefined ? "" : this.LocalizationForm.controls["searchTextBox"].value);
    params = params.append("exportAsTemplate",ExportAsTemplate.toString());

    this.localizationsService.Export(params).subscribe((result) => {
      let FileDTO = result as any
      const file = new Blob([FileDTO], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      
      saveAs(file, `Localizations${this.datePipe.transform(new Date(),"dd-MM-YYYY hh:mm").toString()}.xlsx`);
      
    }, (error) => {
      
    })

  }


  showAddResourceModal(addResourceModal) {
    this.utilityService.startBlockUI();
    this.AddResourceForm = new FormGroup({});


    this.ResourceSet = new AutocompleteOptions();
    this.ResourceSet.Name = "ResourceSet";
    this.ResourceSet.LabelKey = "ResourceSet";
    this.ResourceSet.Type = InputType.Text;
    this.ResourceSet.IsRequired = true;
    this.ResourceSet.Value = null;
    this.ResourceSet.ActionURL = this.environmentService.getApiUrl() + this.ApiUrl + "AutoCompleteResourceSet"
    this.ResourceSet.ValidationToken = this.authService.authorizationHeaderValue()
   
    this.ResourceId = new TextBoxOptions();
    this.ResourceId.Name = "ResourceId";
    this.ResourceId.LabelKey = "ResourceId";
    this.ResourceId.Type = InputType.Text;
    this.ResourceId.Value = null;
    this.ResourceId.IsRequired = true;

    this.MultiLingualValue = new MultiLingualTextAreaOptions();
    this.MultiLingualValue.Name = "Value";
    this.MultiLingualValue.ArabicLabelKey =  "ValueInArabic";
    this.MultiLingualValue.EnglishLabelKey = "ValueInEnglish";
    this.MultiLingualValue.IsRequired = true;

    
    this.MultiLingualComment = new MultiLingualTextAreaOptions();
    this.MultiLingualComment.Name = "Comment";
    this.MultiLingualComment.ArabicLabelKey =  "CommentInArabic";
    this.MultiLingualComment.EnglishLabelKey = "CommentInEnglish";
    this.MultiLingualComment.IsRequired = true;


    this.modalService.open(addResourceModal);
    this.utilityService.stopBlockUI();
  }

  addResource() {
    if (this.AddResourceForm.invalid) {
      return;
    }
    else {
     
      let ResultModel = this.AddResourceForm.value;
       console.log(ResultModel)
      let ResourceModel = new EditResourceModel();
      ResourceModel.ResourceId = ResultModel.ResourceId;
      ResourceModel.ResourceSet = ResultModel.ResourceSet.value;
      ResourceModel.ValueEN = ResultModel.Value.EnglishTextAreaValue;
      ResourceModel.ValueAR = ResultModel.Value.ArabicTextAreaValue;
      ResourceModel.CommentAr = ResultModel.Comment.ArabicTextAreaValue;
      ResourceModel.CommentEn = ResultModel.Comment.EnglishTextAreaValue;

      this.localizationsService.AddResource(ResourceModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
        
      })
    }
  }


  showEditResourceModal(Resource: any, EditResourceModal) {
    this.utilityService.startBlockUI();
    this.EditResourceForm = new FormGroup({});

    this.resourceId = Resource.resourceId
    this.resourceSet = Resource.resourceSet


    let Value=new EnglishArabicDTO();
    Value.Arabic=Resource.valueAR;
    Value.English=Resource.valueEN;

    this.EditMultiLingualValue = new MultiLingualTextAreaOptions();
    this.EditMultiLingualValue.Name = "Value";
    this.EditMultiLingualValue.ArabicLabelKey =  "ValueInArabic";
    this.EditMultiLingualValue.EnglishLabelKey = "ValueInEnglish";
    this.EditMultiLingualValue.IsRequired = true;
    this.EditMultiLingualValue.Value = Value;


    let Comment=new EnglishArabicDTO();
    Comment.Arabic=Resource.commentAr;
    Comment.English=Resource.commentEn;

    this.EditMultiLingualComment = new MultiLingualTextAreaOptions();
    this.EditMultiLingualComment.Name = "Comment";
    this.EditMultiLingualComment.ArabicLabelKey =  "CommentInArabic";
    this.EditMultiLingualComment.EnglishLabelKey = "CommentInEnglish";
    this.EditMultiLingualComment.IsRequired = true;
    this.EditMultiLingualComment.Value = Comment;

    this.modalService.open(EditResourceModal);
    this.utilityService.stopBlockUI();

  }

  editResource() {
    if (this.EditResourceForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditResourceForm.value;
      let ResourceModel = new EditResourceModel();
      ResourceModel.ResourceId = this.resourceId;
      ResourceModel.ResourceSet = this.resourceSet;
      ResourceModel.ValueEN = ResultModel.Value.EnglishTextAreaValue;
      ResourceModel.ValueAR = ResultModel.Value.ArabicTextAreaValue;
      ResourceModel.CommentEn = ResultModel.Comment.EnglishTextAreaValue;
      ResourceModel.CommentAr = ResultModel.Comment.ArabicTextAreaValue;

      this.localizationsService.EditResource(ResourceModel).subscribe((result) => {
         
        this.modalService.dismissAll();
    
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
       
      })
    }
  }


  RestResourceToFactoryDefault(Resource:any) {
      let ResourceModel = new EditResourceModel();
      ResourceModel.ResourceId = Resource.resourceId;
      ResourceModel.ResourceSet = Resource.resourceSet;
      ResourceModel.ValueEN = "";
      ResourceModel.ValueAR ="";
      ResourceModel.CommentEn = "";
      ResourceModel.CommentAr = "";
      this.localizationsService.RestResourceToFactoryDefault(ResourceModel).subscribe((result) => {
    
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
       })
    
  }

  showDeleteResourceModal(Resource: any, DeleteResourceModal) {
    this.utilityService.startBlockUI();
    this.deleteResourceList = []
    this.deleteResourceList.push(Resource);
    this.modalService.open(DeleteResourceModal);
    this.utilityService.stopBlockUI();

  }
  deleteResource() {
    this.localizationsService.DeleteResource(this.deleteResourceList).subscribe((result) => {
      this.deleteResourceList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
    })

  }

  ReloadJsonFile() {
    this.localizationsService.ReloadJsonFile().subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.UpdatePaging();
    }, (error) => {
    })
  }

  RestToFactoryDefault() {
   this.localizationsService.RestToFactoryDefault().subscribe((result) => {
      this.modalService.dismissAll();
      let element = this.input as any;
      element.UpdatePaging();
    }, (error) => {
     
    })
  }

  RestUnmodifiedToFactoryDefault() {
    this.localizationsService.RestUnmodifiedToFactoryDefault().subscribe((result) => {
      let element = this.input as any;
      element.UpdatePaging();
    }, (error) => {
     
    })
  }

  copyInputMessage(){
    this._clipboardService.copy(this.ValueToCopy.toString());
  }
  
 
  GenerateStronglyTypedClass(GenerateStronglyTypedModal) {
    this.localizationsService.GenerateStronglyTypedClass().subscribe((result) => {
      var Value = result as any
      this.StronglyTypedClass = new TextAreaOptions();
      this.StronglyTypedClass.Name = "StronglyTypedClass";
      this.StronglyTypedClass.Value = Value.val.toString();
      this.ValueToCopy=Value.val.toString();
      this.StronglyTypedClass.IsDisabled = true;
      this.StronglyTypedClass.HideLabel = true;
      this.StronglyTypedClass.Rows = 20;
      this.StronglyTypedClass.Cols = 20;
      this.StronglyTypedClass.MaxLength = 1000000;

      this.modalService.open(GenerateStronglyTypedModal);
    }, (error) => {
    })
  }


  ShowUploadModal(UploadJsonFileModal) {
    this.utilityService.startBlockUI();
    this.UploadJsonFileForm = new FormGroup({});

    this.UploadResourceSetOptions = new DropdownOptions();
    this.UploadResourceSetOptions.Name = "SelectedResourceSet"
    this.UploadResourceSetOptions.LabelKey = "ResourceSet"
    this.UploadResourceSetOptions.DataSource = this.ResourceSetList
    this.UploadResourceSetOptions.SingleSelection = true;
    this.UploadResourceSetOptions.AllowSearchFilter = true;
    this.UploadResourceSetOptions.Placeholder = "";


    this.ResourcesFileInput = new FileUploadOptions();
    this.ResourcesFileInput.Name = "ResourcesFile"
    this.ResourcesFileInput.LabelKey = "UploadFile"
    this.ResourcesFileInput.IsMultipleFile = false
    this.ResourcesFileInput.FileUploadAcceptsTypes = [FileType.Excel]
    this.ResourcesFileInput.FileMaxSizeInMB = 10;
    this.ResourcesFileInput.IsRequired = true;

    this.modalService.open(UploadJsonFileModal);
    this.utilityService.stopBlockUI();

  }

  UploadExcelFiles() {
    if (this.UploadJsonFileForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.UploadJsonFileForm.value;
      let ResourceModel = new UploadJsonVM();

      ResourceModel.SelectedResourceSet = ResultModel.SelectedResourceSet;
      ResourceModel.ResourcesFile = {
        FileBase64: ResultModel["ResourcesFile"][0].FileBase64,
        FileName: ResultModel["ResourcesFile"][0].FileName,
        FileSizeInMB: ResultModel["ResourcesFile"][0].FileSizeInMB,
        FileType: ResultModel["ResourcesFile"][0].FileType
      }


      this.localizationsService.UploadExcelFiles( ResourceModel).subscribe((result) => {
        let Result= result as any
         //console.log(Result)
        this.ExcelValidation=Result.val
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();

      }, (error) => {
      
      })
    }
  }
  openResourceValidationModal(ResourceValidationModal) {
    this.modalService.open(ResourceValidationModal);
  }
  confirmExcel(){
    this.utilityService.notifySuccessMessage()
    let element = this.input as any;
    this.LoadDropdownLists();
    this.modalService.dismissAll();
    element.ReinitializePaging();
  }

  showConfirmationModal(type: number, ConfirmationModal) {
    this.utilityService.startBlockUI();
    switch (type) {
      case 1:
        this.HeaderMessage = this.utilityService.getResourceValue("ReloadResources");;
        this.ConfirmationMessage = this.utilityService.getResourceValue("ReloadResourcesConfirmation");
        this.ConfirmationModalType = 1
        break;
      case 2:
        this.HeaderMessage = this.utilityService.getResourceValue("ResetToFactoryDefault");;
        this.ConfirmationMessage = this.utilityService.getResourceValue("ResettoFactoryConfirmation");
        this.ConfirmationModalType =2
        break;

      default:
        break;
    }
    this.modalService.open(ConfirmationModal);
    this.utilityService.stopBlockUI();

  }


}
